import { DashboardMetricSet } from '../../dashboard/dashboard-metric';
import { DashboardEventService } from '../../dashboard/dashboard-event.service';
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'app-dashboard-metric-content-single',
    templateUrl: './dashboard-metric-content-single.component.html',
    styleUrls: ['./dashboard-metric-content-single.component.scss', './dashboard-metric.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DashboardMetricContentSingleComponent implements OnInit {
    @Input()
    dashboardMetricSet: DashboardMetricSet;
    @Input()
    numberOfComparisonValues = 0;

    constructor(private dashboardEventService: DashboardEventService) { }

    ngOnInit() {
    }
}
